import React, { useEffect, useRef } from 'react';
import { ReactComponent as NoSearchDataImg } from 'shared/img/icons/no-options.svg';
import styles from './CurrencySelector.module.scss';
import { Currency } from 'shared/components/CurrencySelect/types';

interface CurrencyOptionsProps {
  options: Currency[];
  handleSelectCurrency: Function;
  selectedCurrency?: Currency | null;
  searchText?: string;
  keyboardSelectedCurrency?: Currency | null;
}

export const CurrencySelectorOptions: React.FC<CurrencyOptionsProps> = ({
  searchText,
  options,
  handleSelectCurrency,
  selectedCurrency,
  keyboardSelectedCurrency,
}: CurrencyOptionsProps): React.ReactNode => {
  const selectedRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [keyboardSelectedCurrency]);
  if (searchText && !options.length) {
    return (
      <div className={styles.noData}>
        <NoSearchDataImg />
        <p>No results</p>
      </div>
    );
  }

  return (
    <div className={styles.currencyListContainer}>
      {options.map((currency) => {
        const isSelectedByKeyboard = keyboardSelectedCurrency?.code === currency.code;
        const itemClassNames = `${isSelectedByKeyboard ? styles.showHover : ''} ${styles.currencyItem} ${
          selectedCurrency?.code === currency.code ? styles.selected : ''
        }`;
        return (
          <div
            ref={isSelectedByKeyboard ? selectedRef : null}
            key={currency.code}
            className={itemClassNames}
            onClick={() => handleSelectCurrency(currency)}
          >
            <div className={styles.currencyCode}>
              {currency.code} ({currency.symbolNative})
            </div>
            <div className={styles.currencyTypeText}>
              {currency.subTitle && <div className={styles.infoTag}>{currency.subTitle}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
